import * as yup from 'yup';
import {
  NAME_REGEXP,
  PHONE_NUMBER_REGEXP
} from '../../../../fieldRegexp'

const errorMessages = {
  // eslint-disable-next-line no-template-curly-in-string
  max: 'Максимальнок количество символов равно ${max}',
  // url: 'Формат поля: ссылка (напр. на телеграм, фейсбук)', Commented out due to new legislation (March 2022)
  url: 'Формат поля: ссылка (напр. на телеграм)',
  // phoneOrEmailOrLink: 'Формат поля: телефон, почта или ссылка (напр. на телеграм, фейсбук)', Commented out due to new legislation  (March 2022)
  phoneOrEmailOrLink: 'Формат поля: телефон, почта или ссылка (напр. на телеграм)',
  email: 'Формат поля: e-mail',
  fileType: 'Поддерживаемые форматы: *.pdf, *.doc, *.docx',
  fileSize: (max: number) => `Максимальный размер файла: ${max / 1e+6}MB`,
};

yup.setLocale({
  string: {
    max: errorMessages.max,
    url: errorMessages.url,
    email: errorMessages.email,
  },
});

const schema = yup.object().shape({
  refereeName: yup.string().max(255).matches(NAME_REGEXP, " "),
  refereeEmail: yup.string().email(),
  refereeSource: yup.string(),
  candidateName: yup.string().max(255).matches(NAME_REGEXP, " "),
  vacancyName: yup.string().max(255),
  wayToConnect: yup.string().max(255).test('phoneOrEmailOrLink', errorMessages.phoneOrEmailOrLink, (value) => {
    const schemas = [
      yup.string().matches(PHONE_NUMBER_REGEXP),
      yup.string().email(),
      yup.string().url()
    ];

    return schemas.some((schema) => {
      try {
        schema.validateSync(value);
        return true;
      } catch (e) {
        return false;
      }
    });
  }),
  // https://github.com/formium/formik/issues/926#issuecomment-423704202
  cv: yup.mixed().test('fileType', errorMessages.fileType, (value) => {
    if (value === null) return true;
    return ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(value.type);
  }).test('fileSize', errorMessages.fileSize(2e+6), (value) => {
    if (value === null) return true;
    return value.size <= 2e+6;
  }),
  additionalLinks: yup.array().of(yup.string().url().max(255)),
});

export default schema;
